import * as React from 'react';
import { SVGProps } from 'react';

const IconYandexDzenSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 11.798c4.114-.047 6.417-.316 7.95-1.849 1.532-1.532 1.801-3.835 1.848-7.948-5.363.106-9.69 4.434-9.797 9.797ZM12.396 2.006c.047 4.11.317 6.411 1.849 7.943 1.508 1.509 3.763 1.793 7.756 1.847-.107-5.298-4.332-9.585-9.605-9.79ZM21.995 12.398c-3.99.054-6.243.339-7.75 1.847-1.508 1.507-1.793 3.76-1.847 7.75a10.002 10.002 0 0 0 9.597-9.597ZM11.796 22c-.054-3.993-.338-6.247-1.847-7.755-1.531-1.532-3.832-1.802-7.943-1.85.205 5.274 4.492 9.5 9.79 9.606Z" />
  </svg>
);
export default IconYandexDzenSizeM;
